import { useAtom } from "jotai";
import { useMemo } from "react";

import { getTotalSweepEntries, handleAssetUrl } from "../../../shared/utils";
import {
  SMS_EXTRA_ENTRIES,
  COMPANY_FORM_EXTRA_ENTRIES,
  RE_WEBSITE_URL,
  LOGO_URL,
} from "../../restaurant-equippers.constants";
import {
  smsCompletedAtom,
  companyFormCompletedAtom,
} from "../../restaurant-equippers.state";

export function ConfirmationPage(): JSX.Element {
  const [smsCompleted] = useAtom(smsCompletedAtom);
  const [companyFormCompleted] = useAtom(companyFormCompletedAtom);

  const totalEntries = useMemo((): number => {
    const submission = window.theme.Sweepstake.prototype.retrieveSubmission();
    return getTotalSweepEntries(submission?.data);
  }, []);

  const earnedEntries = useMemo(
    (): number =>
      (smsCompleted ? SMS_EXTRA_ENTRIES : 0) +
      (companyFormCompleted ? COMPANY_FORM_EXTRA_ENTRIES : 0),
    [smsCompleted, companyFormCompleted]
  );

  return (
    <div className="re__confirmation-wrapper">
      <div
        className="re__confirmation-header"
        style={{
          backgroundImage: `url(${handleAssetUrl("confetti.gif")})`,
        }}
      >
        <span className="re__confirmation-header--title">Congratulations!</span>
      </div>

      <div className="re__confirmation-content">
        <p className="re__confirmation-content--thank-you">
          Thank you for your submission!
        </p>

        {earnedEntries > 0 && (
          <p className="re__confirmation-content--earned">
            You have earned <strong>+{earnedEntries}</strong> additional{" "}
            {earnedEntries === 1 ? "entry" : "entries"} from Restaurant
            Equippers!
          </p>
        )}

        <div className="re__confirmation-content--entries-badge">
          <span className="re__confirmation-content--entries-number">
            {totalEntries}
          </span>
          <span className="re__confirmation-content--entries-label">
            total {totalEntries === 1 ? "entry" : "entries"}
          </span>
        </div>

        <a
          href={RE_WEBSITE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="re__confirmation-content--cta-link"
        >
          <img
            src={LOGO_URL}
            alt="Restaurant Equippers Logo"
            className="re__confirmation-content--cta-logo"
          />
          <span>Visit RestaurantEquippers.com</span>
          <img
            src={handleAssetUrl("external-link-icon.svg")}
            alt="External link"
            className="re__confirmation-content--cta-icon"
          />
        </a>
      </div>
    </div>
  );
}
